import { Container, Hidden } from "@mui/material";
import React, { useState, useEffect, useCallback, useMemo } from "react";
import Sidebar from "./SideBar";
import { Button, Navbar, Nav, NavDropdown, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  HddStack,
  List,
  Grid3x3Gap,
  HddStackFill,
  HouseDoorFill,
} from "react-bootstrap-icons";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { without } from "lodash";
import NavDropDown from "./NavDropDown";
import HomePage from "./HomePage";
import Estructuras from "./Estructuras";
import NuevosActivos from "./activos/NuevosActivos.js";
import EnhancedTable from "./Evaluaciones/Mtable_Evaluaciones.js";
import Riesgos from "./Evaluaciones/MainRiesgos.js";
import Frecuencia from "./Evaluaciones/Frecuencia";
import MainActivosInformacion from "./activos/MainActivosInformacion.js";
import ActivosInfo from "./activos/Mtable_MainActivos.js";
import Nueva_evaluacion from "./Evaluaciones/Nueva_evaluacion.js";
import EditarEvaluacion from "./Evaluaciones/EditarEvaluacion.js";
import Proveedores from "./proveedores/Mtable_Proveedores.js";
import Nuevo_proveedor from "./proveedores/Nuevo_proveedor.js";
import CuestionarioEvaluacion from "./Evaluaciones/CuestionarioEvaluacion";
import Vul_no_tec from "./Evaluaciones/Vulnerabilidades/Vul_no_tec_Padre";
import Controles from "./Evaluaciones/MainControles.js";
import ResumenEfectividad from "./Evaluaciones/ResumenEfectividad";
import EscenariosMitigacion from "./Evaluaciones/EscenariosMitigacion";
import componentes from "./componentes/Mtable_Componentes.js";
import MainComponente from "./componentes/MainComponente.js";
import nuevoComponente from "./componentes/NuevoComponente.js";
import proyectos from "./proyectos/Mtable_Proyectos.js";
import nuevo_proy from "./proyectos/Nuevo_proyecto.js";
import tecnologias from "./tecnologia/Mtable_Tecnologias.js";
import nueva_tec from "./tecnologia/Nueva_tecnologia.js";
import Mtable_Controles from "./Mcontroles/Mtable_Controles.js";
import NuevosMControles from "./Mcontroles/NuevoMControles.js";
import EditarMControles from "./Mcontroles/EditarMControles.js";
import Mtable_Implementadores from "./Mimplementadores/MainImplementadores.js";
import NuevosMImplementadores from "./Mimplementadores/NuevoMImplementadores.js";
import EditarMImplementadores from "./Mimplementadores/EditarMImplementadores";
import "./index.css";
import logo from "./main_icon.png";
import EditarActivo from "./activos/EditarActivo.js";
import MainEditarComponente from "./componentes/MainEditarComponente.js";
import EfectosPropios from "./componentes/EfectosPropios.js";
import componentesInfra from "./componentesInfra/Mtable_ComponentesInfra.js";
import nuevoComponenteInfra from "./componentesInfra/NuevoComponenteInfra.js";
import EditarComponenteInfra from "./componentesInfra/EditarComponenteInfra.js";
import CuestionarioAdmin from "./Administracion/CuestionarioAdmin.js";
import CuestionarioConsulta from "./Administracion/CuestionarioConsulta.js";
import EditarProveedor from "./proveedores/EditarProveedor.js";
import EditarTecnologia from "./tecnologia/EditarTecnologia";
import EditarProyecto from "./proyectos/EditarProyecto";
import Vul_tec from "./Evaluaciones/Vulnerabilidades/Vul_tec.js";
import MainVul from "./Evaluaciones/Vulnerabilidades/MainVulnerabilidades.js";
import Eliminar_vul_tec from "./Evaluaciones/Vulnerabilidades/Eliminar_vul_tec.js";
import Descripcion_comp from "./Evaluaciones/descripcion_comp";
import AADService from "./funcionesAuth.js";
import PlanesAccion from "./planesAccion/Mtable_PlanesAccion";
import NuevoPlanAccion from "./planesAccion/NuevoPlanAccion";
import EditarPlanAccion from "./planesAccion/EditarPlanAccion";
import NewPlanesAccio from "./NewPlanesDeAccion/NewPlanesDesAccion.js"
import NewNuevoPlanesAccion from "./NewPlanesDeAccion/NewNuevoPlanAccion.js";
import NewEditarPlanesAccion from "./NewPlanesDeAccion/NewEditarPlanesDeAccion.js";
import Desiciones from "./decisiones/Decisiones";
import EditarDecisiones from "./decisiones/EditarDecisiones";
import Regulatorio from "./Administracion/Regulatorio.js";
import Informes from "./Administracion/Informes.js";
import InformeVSC from "./Administracion/InformeVSC.js";
import DescargaLogs from "./Administracion/DescargaLogs.js";
import CrearUsuario from "./Administracion/CrearUsuario.js";
import FrecuenciasSOC from "./Administracion/FrecuenciaSOC";
import CheckRole from "./CheckRole";
import { Check } from "@mui/icons-material";
import { DecryptData } from "./DatosEncriptados/EncryptedFunctions";
import MTableRolView from "./Roles/MTableRolView/MTableRolView";
import EditTableRolView from "./Roles/EditTableRolView/EditTableRolView";
import NewRolView from "./Roles/NewRolView/NewRolView";
import MtableRegulatorioView from "./estadisticasRegulatorio/MtableRegulatorioView/MtableRegulatorioView";
import Valoraciones from "./Valoracion/MValoracion.js";
import CrearEfecto from "./Valoracion/CrearEfecto.js";
import EditarEfecto from "./Valoracion/EditarEfecto.js";
import AgregarEfecto from "./Valoracion/AgregarEfecto.js";
import AdminEfectividad from "./Administracion/AdminEfectividad.js";
import IconButton from "@material-ui/core/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";
import CountdownTimer from "./CountdownTimer";
import EditarAgregarEfectos from "./Valoracion/EditarAgregarEfecto.js";
import Adjuntos from "./Administracion/Adjuntos.js";
import MTableRiesgos from "./Taxonomias/Mtable_Riesgos.js";
import Mtable_vulnerabilidades from "./Taxonomias/Mtable_Vulnerabilidades.js";
import EditarMVulnerabilidad from "./Taxonomias/EditarMVulnerabilidad.js";
import Mtable_amenazas from "./Taxonomias/Mtable_Amenazas.js";
import EditarAmenazas from "./Taxonomias/EditarAmenazas.js";
import MTableLineasBase from "./LineasBase/MTableLineasBase.js";
import EditarLineaBase from "./LineasBase/EditarMLineaBase.js";
import EthicalHacking from "./hacking/Mtable_EthicalHacking.js";
import NuevoEthicalHacking from "./hacking/NuevoEthicalHacking.js";
import EditarEthicalHacking from "./hacking/EditarEthicalHacking.js";
import S3View from "./Administracion/S3View.js";
import M_Opcion from "./opciones/MTableOpcion.js";
import NuevaOpcion from "./opciones/NuevaOpcion.js";
import EditarOpcion from "./opciones/EditarOpcion.js";
import ConsultasSql from "./ConsultasSql/ConsultasSql.js"
import Mtable_NewEvaluaciones from "./Evaluaciones/newEvaluaciones/Mtable_NewEvaluaciones.js";
import MainNewEvaluacion from "./Evaluaciones/newEvaluaciones/MainNewEvaluacion.js"
import NuevosRiesgos from "./Evaluaciones/newEvaluaciones/MainRiesgosNew.js"
import NuevoCuestionarioEvaluacion from "./Evaluaciones/NuevoCuestionarioEvaluacion.js";
import MasterFindings from "./Evaluaciones/newVulnerabilidades/MasterFindings.js";
import EvaluacionesPadre from "./Evaluaciones/EvaluacionesPadre.js";
import MainControlesNew from "./Evaluaciones/newEvaluaciones/MainControlesNew.js";
import InformesPendientes from "./Administracion/InformesPendiente.js";
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import PendientesAnalista from "./pendientes/pendientesAnalista.js";
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import TaskTable from './ListaTareas.js'
import { withRouter } from "react-router-dom";
import ParametrosGenerales from "./Administracion/ParametrosGenerales.js";
import TablaAlertas from "./pendientes/MainAlertas.js";
import VistasProcesos from "./Administracion/VistaProcesos.js";
import VistaVulnModel from "./Administracion/VulnModel.js";


const initializeLocalStorage = () => {
  if (!localStorage.getItem("variable_tipo_activo")) {
    localStorage.setItem("variable_tipo_activo", "0");
  }
  if (!localStorage.getItem("idevaluacion")) {
    localStorage.setItem("idevaluacion", "0");
  }
};

// Hook personalizado para datos de usuario optimizado
const useUserData = (login) => {
  const [userData, setUserData] = useState({
    parametros: [],
    idrol: localStorage.getItem('rolusuario') || 0,
    rol: "",
    id_compania_ppal: 0,
    nombre: "",
    nombre_compania_ppal: "",
    companias: [],
    loading: true,
    error: null
  });
  const AzureADService = new AADService();
  const token = AzureADService.getToken();
  const unicodeCorreo = useCallback((correo) => {
    let total = "";
    for (let i = 0; i < correo.length; i++) {
      total += "/" + correo.charCodeAt(i);
    }
    return Buffer.from(total, "ascii").toString("base64");
  }, []);

  const processMenuData = useCallback((param) => {
    const menu_usuario = [];

    // Filtrar elementos padre de forma más eficiente
    Object.values(param).forEach(item => {
      if (item.padre === 0 || item.padre === 12) {
        menu_usuario.push(item);
      }
    });

    // Asignar items a cada elemento del menú
    menu_usuario.forEach(menuItem => {
      const items = [];
      Object.values(param).forEach(item => {
        if (menuItem.idopcion === item.padre) {
          items.push(item);
        }
      });
      menuItem.items = items;
    });

    return menu_usuario;
  }, []);

  useEffect(() => {
    let isMounted = true;

    const fetchUserData = async () => {
      if (!login) return;

      try {
        let correo = login + "@bancolombia.com.co";
        correo = unicodeCorreo(correo);
        localStorage.setItem("usuario", correo);

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}usuarios/menu/${correo}/`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const encryptedParam = await response.json();
        const decryptedParam = DecryptData(encryptedParam);
        const param = JSON.parse(decryptedParam);
        const menu_usuario = processMenuData(param);

        if (menu_usuario.length > 0 && isMounted) {
          const firstMenuItem = menu_usuario[0];

          localStorage.setItem("idusuario", firstMenuItem.idusuario || "");
          localStorage.setItem("rolusuario", firstMenuItem.idrol || "");
          localStorage.setItem("idposicion", firstMenuItem.idposicion || "");
          localStorage.setItem("idcompania", firstMenuItem.idcompania || "0");

          setUserData({
            parametros: menu_usuario,
            idrol: firstMenuItem.idrol,
            rol: firstMenuItem.nombre_rol || "",
            id_compania_ppal: firstMenuItem.idcompania || 0,
            nombre: firstMenuItem.nombre || "",
            nombre_compania_ppal: "",
            companias: [],
            loading: false,
            error: null
          });
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        if (isMounted) {
          setUserData(prev => ({
            ...prev,
            loading: false,
            error: error.message
          }));
        }
      }
    };

    fetchUserData();

    return () => {
      isMounted = false;
    };
  }, [login, unicodeCorreo, processMenuData]);

  return userData;
};

// Componente principal optimizado como functional component
const Menu = ({ login }) => {
  const [menuState, setMenuState] = useState({
    count: true,
    orden_menu: parseInt(localStorage.getItem("idevaluacion") || "0"),
    tienePendientes: true,
    isOffcanvasOpen: false,
    showModalPendientes: false,
  });

  const userData = useUserData(login);

  // Inicializar localStorage al montar
  useEffect(() => {
    initializeLocalStorage();
  }, []);

  // Handler optimizado para cambios de menú
  const handler = useCallback(() => {
    const newOrden = parseInt(localStorage.getItem("idevaluacion") || "0");
    setMenuState(prev => ({ ...prev, orden_menu: newOrden }));
  }, []);

  // Toggle menu optimizado con requestAnimationFrame
  const toggleMenu = useCallback(() => {
    setMenuState(prev => {
      const newCount = !prev.count;

      // Usar requestAnimationFrame para cambios de DOM más suaves
      requestAnimationFrame(() => {
        const sidenav = document.getElementById("contenedor_sidenav");
        const pages = document.getElementById("contenedor_paginas");

        if (sidenav && pages) {
          if (!newCount) {
            sidenav.style.width = "0";
            pages.style.marginLeft = "0";
          } else {
            sidenav.style.width = "240px";
            pages.style.marginLeft = "240px";
          }
        }
      });

      return { ...prev, count: newCount };
    });
  }, []);

  const handleHomeClick = useCallback(() => {
    setMenuState(prev => ({ ...prev, orden_menu: 0 }));
    localStorage.setItem("idevaluacion", "0");
  }, []);

  const toggleOffcanvas = useCallback(() => {
    setMenuState(prev => ({
      ...prev,
      isOffcanvasOpen: !prev.isOffcanvasOpen,
      tienePendientes: prev.isOffcanvasOpen ? false : prev.tienePendientes,
    }));
  }, []);

  // Componente de rutas memoizado para evitar re-renders innecesarios
  const AppRoutes = useMemo(() => (
    <>
      <Route path="/" component={HomePage} exact />

      {/* Rutas de administración */}
      <Route path="/regulatorio" component={Regulatorio} exact />
      <Route path="/frecuencias" component={FrecuenciasSOC} exact />
      <Route path='/informes' component={Informes} exact />
      <Route path='/informes-pendientes' component={InformesPendientes} exact />
      <Route path="/descarga-logs" component={DescargaLogs} exact />
      <Route path="/usuario" component={CrearUsuario} exact />
      <Route path="/parametros-generales" component={ParametrosGenerales} exact />

      {/* Rutas principales */}
      <Route path="/estructuras" component={Estructuras} exact />
      <Route path="/tareas" component={TaskTable} exact />
      <Route path="/dominio-de-informacion" component={ActivosInfo} exact />
      <Route path="/NuevoActivo" component={NuevosActivos} exact />
      <Route path="/EditarActivo" component={EditarActivo} exact />
      <Route path="/MainActivosInformacion" component={MainActivosInformacion} exact />

      {/* Rutas de componentes */}
      <Route path="/componente-tecnologico" component={MainComponente} exact />
      <Route path="/NuevoComponente" component={nuevoComponente} exact />
      <Route path="/MainEditarComponente" component={MainEditarComponente} exact />
      <Route path="/EfectosPropios" component={EfectosPropios} exact />
      <Route path="/componente-infraestructura" component={componentesInfra} exact />
      <Route path="/NuevoComponenteInfra" component={nuevoComponenteInfra} exact />
      <Route path="/EditarComponenteInfra" component={EditarComponenteInfra} exact />

      {/* Rutas de evaluaciones */}
      <Route path="/evaluaciones" render={() => <EnhancedTable action={handler} />} exact />
      <Route path="/nueva_eval" render={() => <Nueva_evaluacion action={handler} />} exact />
      <Route path="/new-evaluaciones" render={() => <MainNewEvaluacion action={handler} />} exact />
      <Route path="/detalle-evaluacion" render={() => <EvaluacionesPadre action={handler} />} exact />
      <Route path="/EditarEvaluacion" render={() => <EditarEvaluacion action={handler} />} exact />
      <Route path="/descripcion-de-componentes" component={Descripcion_comp} exact />
      <Route path="/evaluacion-riesgo" component={Riesgos} exact />
      <Route path="/NuevosRiesgos" component={NuevosRiesgos} exact />
      <Route path="/frecuencia-riesgos" component={Frecuencia} exact />
      <Route path="/evaluacion-cuestionario-de-riesgos" component={CuestionarioEvaluacion} exact />
      <Route path="/nuevo-cuestionario-de-riesgos" component={NuevoCuestionarioEvaluacion} exact />
      <Route path="/cuestionario-admin" component={CuestionarioAdmin} exact />
      <Route path="/cuestionario-consulta" component={CuestionarioConsulta} exact />

      {/* Rutas de vulnerabilidades */}
      <Route path="/evaluacion-vulnerabilidades-no-tecnicas" component={Vul_no_tec} exact />
      <Route path="/evaluacion-vulnerabilidades-tecnicas" component={Vul_tec} exact />
      <Route path="/evaluacion-eliminar-vulnerabilidades-tecnicas" component={MainVul} exact />
      <Route path="/findings" component={MasterFindings} exact />
      <Route path="/eliminar-vul" component={Eliminar_vul_tec} exact />

      {/* Rutas de controles */}
      <Route path="/controles-evaluacion" component={Controles} exact />
      <Route path="/new-controles-evaluacion" component={MainControlesNew} exact />

      {/* Rutas de proveedores */}
      <Route path="/proveedores" component={Proveedores} exact />
      <Route path="/nuevo_prov" component={Nuevo_proveedor} exact />
      <Route path="/EditarProveedor" component={EditarProveedor} exact />

      {/* Rutas de proyectos y tecnologías */}
      <Route path="/proyecto" component={proyectos} exact />
      <Route path="/NuevoProyecto" component={nuevo_proy} exact />
      <Route path="/EditarProyecto" component={EditarProyecto} exact />
      <Route path="/tecnologia-emergente" component={tecnologias} exact />
      <Route path="/NuevaTecnologia" component={nueva_tec} exact />
      <Route path="/EditarTecnologia" component={EditarTecnologia} exact />

      {/* Rutas de taxonomías */}
      <Route path="/tipos-de-riesgos" component={MTableRiesgos} exact />
      <Route path="/tipos-de-vulnerabilidades" component={Mtable_vulnerabilidades} exact />
      <Route path="/EditarMvulnerabilidad" component={EditarMVulnerabilidad} exact />
      <Route path="/tipos-de-amenazas" component={Mtable_amenazas} exact />
      <Route path="/EditarAmenazas" component={EditarAmenazas} exact />

      {/* Rutas de controles maestros */}
      <Route path="/maestro-controles" component={Mtable_Controles} exact />
      <Route path="/NuevoMControl" component={NuevosMControles} exact />
      <Route path="/EditarMControl" component={EditarMControles} exact />
      <Route path="/maestro-implementador" component={Mtable_Implementadores} exact />
      <Route path="/NuevoMimplementador" component={NuevosMImplementadores} exact />
      <Route path="/EditarMimplementador" component={EditarMImplementadores} exact />

      {/* Rutas de planes de acción */}
      <Route path="/planes-de-accion" component={PlanesAccion} exact />
      <Route path="/NuevoPlanAccion" component={NuevoPlanAccion} exact />
      <Route path="/EditarPlanAccion" component={EditarPlanAccion} exact />

      {/* Rutas New Planes de accion*/}
      <Route path="/NewPlanAccion" component={NewPlanesAccio} exact />
      <Route path="/NewEditarPlanAccion" component={NewEditarPlanesAccion} exact />
      <Route path="/NewNuevoPlanAccion" component={NewNuevoPlanesAccion} exact />

      {/* Rutas de decisiones */}
      <Route path="/decisiones" component={Desiciones} exact />
      <Route path="/EditarDecisiones" component={EditarDecisiones} exact />

      {/* Rutas adicionales */}
      <Route path="/lineas-base" component={MTableLineasBase} exact />
      <Route path="/EditarLineaBase" component={EditarLineaBase} exact />
      <Route path="/roles" component={MTableRolView} exact />
      <Route path="/edit-roles" component={EditTableRolView} exact />
      <Route path="/new-role" component={NewRolView} exact />
      <Route path="/estadisticas-Regulatorio" component={MtableRegulatorioView} exact />
      <Route path="/alertas" component={TablaAlertas} exact />

      {/* Rutas de valoraciones */}
      <Route path="/valoraciones" component={Valoraciones} exact />
      <Route path="/crearEfecto" component={CrearEfecto} exact />
      <Route path="/agregarEfectos" component={AgregarEfecto} exact />
      <Route path="/EditarEfecto" component={EditarEfecto} exact />
      <Route path="/editarAgregarEfectos" component={EditarAgregarEfectos} exact />

      {/* Rutas de ethical hacking */}
      <Route path="/ethical-hacking" component={EthicalHacking} exact />
      <Route path="/NuevoEthicalHacking" component={NuevoEthicalHacking} exact />
      <Route path="/EditarEthicalHacking" component={EditarEthicalHacking} exact />

      {/* Rutas de opciones */}
      <Route path="/opciones" component={M_Opcion} exact />
      <Route path="/NuevaOpcion" component={NuevaOpcion} exact />
      <Route path="/EditarOpcion" component={EditarOpcion} exact />

      {/* Rutas de administración adicionales */}
      <Route path="/informe-vsc" component={InformeVSC} exact />
      <Route path="/admin-efectividad" component={AdminEfectividad} exact />
      <Route path="/adjuntos" component={Adjuntos} exact />
      <Route path="/s3view" component={S3View} exact />
      <Route path="/consultas" component={ConsultasSql} exact />
      <Route path="/procesos" component={VistasProcesos} exact />
      <Route path="/VulnModel" component={VistaVulnModel} exact />

    </>
  ), [handler]);

  // Loading state
  if (userData.loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column'
      }}>
        <div>Cargando aplicación...</div>
      </div>
    );
  }

  // Error state
  if (userData.error) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h3>Error al cargar la aplicación</h3>
        <p>{userData.error}</p>
        <button onClick={() => window.location.reload()}>
          Reintentar
        </button>
      </div>
    );
  }
  

  return (
    <div id="principal">
      <Router>
        <Row id="menu_titulo">
          <Col xs={12} style={{ paddingRight: "0px" }}>
            <nav className="navbar navbar-dark" id="nav_header">
              <Button variant="#ffffff" size="lg" onClick={toggleMenu}>
                <List />
              </Button>
              <Link to="menu">
                <Button variant="#787878" size="lg" onClick={handleHomeClick}>
                  <HouseDoorFill />
                </Button>
              </Link>
              <Navbar.Brand></Navbar.Brand>
              <Navbar.Brand className="titulo" href="#home">
                <img src={logo} alt="" className="logonav" />
                GRC Riesgos tecnológicos y cibernéticos
              </Navbar.Brand>
              <Nav className="mr-auto">
                <Nav.Link href="#home"></Nav.Link>
              </Nav>

              <div>
                {(userData.idrol == 1 || userData.idrol == 2) && (
                  <NotificationImportantIcon
                    className={`icono-con-punto ${menuState.tienePendientes ? 'titilando' : ''}`}
                    style={{ marginRight: '10px', cursor: 'pointer' }}
                    onClick={toggleOffcanvas}
                  />
                )}

                {menuState.isOffcanvasOpen && (
                  <div className="overlay" onClick={toggleOffcanvas}></div>
                )}

                <div className={`offcanvas ${menuState.isOffcanvasOpen ? "open" : ""}`}>
                  <button className="close-btn" onClick={toggleOffcanvas}>
                    &times;
                  </button>
                  <ul>
                    <Route
                      render={(props) => (
                        <PendientesAnalista
                          action={handler}
                          cerrarOffcanvas={toggleOffcanvas}
                          {...props}
                        />
                      )}
                      exact
                    />
                  </ul>
                </div>
              </div>

              <label className="texto">{userData.nombre}</label>
              <label className="texto">{userData.rol}</label>
              <NavDropDown
                className="texto"
                rol={userData.rol}
                compania={userData.nombre_compania_ppal}
                companias={userData.companias}
                id_compania_ppal={userData.id_compania_ppal}
              />
            </nav>
          </Col>
        </Row>

        <div id="contenedor_principal">
          <div id="contenedor_sidenav">
            <Sidebar
              items={userData.parametros}
              orden_menu={menuState.orden_menu}
              eval_type={localStorage.getItem("eval_type")}
            />
          </div>

          <div id="contenedor_paginas">
            {AppRoutes}
          </div>
        </div>
      </Router>
    </div>
  );
};

export default Menu;